import { Component } from '@angular/core';
import { HeaderComponent } from '@plantefeve/common/shared/components/header/header.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'igx-no-access',
  imports: [HeaderComponent, TranslatePipe],
  template: `
    <igx-header [title]="'noAccessTitle' | translate"></igx-header>
    <section class="portal-notice">
      <p class="portal-notice__message">{{ 'noAccessMessage' | translate }}</p>
    </section>
  `,
})
export class NoAccessComponent {}
